// @flow
import * as React from 'react';
import { Navbar, Nav } from 'react-bootstrap';

import LanguageSelect from './components/LanguageSelect/LanguageSelect';
import Account from './components/Account/Account';
import style from './style';

import logo from './virtaskHeaderLogo.png';

type Props = {
  children?: React.Node,
};

const Header = ({ children }: Props) => (
  <Navbar>
    <Navbar.Header>
      <Navbar.Brand>
        <a href="http://virtask.nl/" style={style.brandStyle}><img style={style.logoStyle} src={logo} alt="Virtask logo" /></a>
      </Navbar.Brand>
    </Navbar.Header>
    {children}
    <Nav pullRight>
      <LanguageSelect />
      <Account />
    </Nav>
  </Navbar>
);

Header.defaultProps = {
  children: <span />,
};

export default Header;



// WEBPACK FOOTER //
// ./src/scenes/components/Header/Header.js